
import { Country } from './models/country';

const countries: Country[] = [
    {
      alpha2Code: 'AI',
      name: 'Anguilla',
    },
    {
      alpha2Code: 'AG',
      name: 'Antigua and Barbuda',
    },
    {
      alpha2Code: 'AR',
      name: 'Argentina',
    },
    {
      alpha2Code: 'AW',
      name: 'Aruba',
    },
    {
      alpha2Code: 'BS',
      name: 'Bahamas',
    },
    {
      alpha2Code: 'BB',
      name: 'Barbados',
    },
    {
      alpha2Code: 'BZ',
      name: 'Belize',
    },
    {
      alpha2Code: 'BM',
      name: 'Bermuda',
    },
    {
      alpha2Code: 'BO',
      name: 'Bolivia',
    },
    {
      alpha2Code: 'BQ',
      name: 'Bonaire',
    },
    {
      alpha2Code: 'BR',
      name: 'Brasil',
    },
    {
      alpha2Code: 'UM',
      name: 'United States Minor Outlying Islands',
    },
    {
      alpha2Code: 'VG',
      name: 'British Virgin Islands',
    },
    {
      alpha2Code: 'VI',
      name: 'Virgin Islands of the United States',
    },
    {
      alpha2Code: 'CA',
      name: 'Canada',
    },
    {
      alpha2Code: 'KY',
      name: 'Cayman Islands',
    },
    {
      alpha2Code: 'CL',
      name: 'Chile',
    },
    {
      alpha2Code: 'CO',
      name: 'Colombia',
    },
    {
      alpha2Code: 'CR',
      name: 'Costa Rica',
    },
    {
      alpha2Code: 'CU',
      name: 'Cuba',
    },
    {
      alpha2Code: 'CW',
      name: 'Curaçao',
    },
    {
      alpha2Code: 'DM',
      name: 'Dominica',
    },
    {
      alpha2Code: 'DO',
      name: 'República Dominicana',
    },
    {
      alpha2Code: 'EC',
      name: 'Ecuador',
    },
    {
      alpha2Code: 'SV',
      name: 'El Salvador',
    },
    {
      alpha2Code: 'FK',
      name: 'Falkland Islands',
    },
    {
      alpha2Code: 'GF',
      name: 'Guyane française',
    },
    {
      alpha2Code: 'GL',
      name: 'Kalaallit Nunaat',
    },
    {
      alpha2Code: 'GD',
      name: 'Grenada',
    },
    {
      alpha2Code: 'GP',
      name: 'Guadeloupe',
    },
    {
      alpha2Code: 'GT',
      name: 'Guatemala',
    },
    {
      alpha2Code: 'GY',
      name: 'Guyana',
    },
    {
      alpha2Code: 'HT',
      name: 'Haïti',
    },
    {
      alpha2Code: 'HN',
      name: 'Honduras',
    },
    {
      alpha2Code: 'JM',
      name: 'Jamaica',
    },
    {
      alpha2Code: 'MQ',
      name: 'Martinique',
    },
    {
      alpha2Code: 'MX',
      name: 'México',
    },
    {
      alpha2Code: 'MS',
      name: 'Montserrat',
    },
    {
      alpha2Code: 'NI',
      name: 'Nicaragua',
    },
    {
      alpha2Code: 'PA',
      name: 'Panamá',
    },
    {
      alpha2Code: 'PY',
      name: 'Paraguay',
    },
    {
      alpha2Code: 'PE',
      name: 'Perú',
    },
    {
      alpha2Code: 'PR',
      name: 'Puerto Rico',
    },
    {
      alpha2Code: 'BL',
      name: 'Saint-Barthélemy',
    },
    {
      alpha2Code: 'KN',
      name: 'Saint Kitts and Nevis',
    },
    {
      alpha2Code: 'LC',
      name: 'Saint Lucia',
    },
    {
      alpha2Code: 'MF',
      name: 'Saint-Martin',
    },
    {
      alpha2Code: 'PM',
      name: 'Saint-Pierre-et-Miquelon',
    },
    {
      alpha2Code: 'VC',
      name: 'Saint Vincent and the Grenadines',
    },
    {
      alpha2Code: 'SX',
      name: 'Sint Maarten',
    },
    {
      alpha2Code: 'GS',
      name: 'South Georgia',
    },
    {
      alpha2Code: 'SR',
      name: 'Suriname',
    },
    {
      alpha2Code: 'TT',
      name: 'Trinidad and Tobago',
    },
    {
      alpha2Code: 'TC',
      name: 'Turks and Caicos Islands',
    },
    {
      alpha2Code: 'US',
      name: 'United States',
    },
    {
      alpha2Code: 'UY',
      name: 'Uruguay',
    },
    {
      alpha2Code: 'VE',
      name: 'Venezuela',
    },
    {
      alpha2Code: 'ES',
      name: 'España',
    },
  ];

export default countries;
